import { FC } from 'react';
import { nameof } from '../../utils/stringUtils';
import PercentageSpinButton from '../queues/PercentageSpinButton';
import ThresholdField from './ThresholdField';

interface IProps {
  label: string;
  tooltip?: string;
  value: number | null;
  onChange(value: number | null): void;
}

const PercentageEditor: FC<IProps> = ({ label, tooltip, value, onChange }) => (
  <ThresholdField
    label={label}
    tooltip={tooltip}
    enabled={value !== null}
    onEnabledChange={(enabled) => onChange(enabled ? 0.01 : null)}
  >
    <PercentageSpinButton
      disabled={value === null}
      value={value ?? 0}
      onChange={onChange}
      width={75}
    />
  </ThresholdField>
);

PercentageEditor.displayName = nameof({ PercentageEditor });
export default PercentageEditor;